// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed493583","373":"af0179dd","433":"0e22157f","447":"ac040246","455":"08711360","749":"93f8364f","903":"8239d18a","967":"b9e9cc93","977":"d3702c5e"}[chunkId] + ".chunk.js";
};